import React, { useState, useEffect } from 'react'
import { IonContent, IonPage } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { useHistory } from "react-router-dom";

import LayoutGap from '../../layouts/LayoutGap';
import AddComment from '../../components/comment/AddComment';
import Toolbar from '../../layouts/Toolbar';
import Comments from '../comments/Comments';

import './BlogDetailPage.css'
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { BlogCommentsAction } from '../../redux/actions/Blog';

interface Props extends RouteComponentProps<{
    blog_id: string,
    type: string
}> { }

const BlogDetailPage: React.FC<Props> = ({ match }) => {
    const history = useHistory();
    const dispatch = useAppDispatch();

    const { loading, blogComments } = useAppSelector(state => state.blogCommentsGet);
    const [comments, setComments] = useState(history.location.state as any);
    const [commentsData, setCommentsData] = useState({ event: null as any, currentPage: 0 });

    const [title, setTitle] = useState("")
    const [activeComponent, setActiveComponent] = useState(null as any)
    const [addCommentButtonVisible, setAddCommentButtonVisible] = useState(false)
    const [showAddCommentModal, setShowAddCommentModal] = useState(false);

    const commentsLoadMore = (e: any) => {
        const currentPage = commentsData.currentPage + 1

        setCommentsData({ event: e, currentPage: currentPage })

        dispatch(BlogCommentsAction(match.params.blog_id, currentPage))
    }

    useEffect(() => {
        if (blogComments != null && !loading) {
            if (commentsData.event?.target != null) {
                commentsData.event?.target.complete();

                const items = comments.concat(blogComments.comments);

                commentsData.event.target.disabled = (items.length == blogComments.commentsTotal);

                setComments(items);

                setActiveComponent(<Comments data={items} loadMore={commentsLoadMore} />)
            }
        }
    }, [loading])

    useEffect(() => {
        if (match.params.type == 'comments') {
            setTitle("نظرات")
            setActiveComponent(<Comments data={comments} loadMore={commentsLoadMore} />)
            setAddCommentButtonVisible(true)
        }
    }, [])

    const showCommentHandler = () => {
        setShowAddCommentModal(true);
    }

    const hideCommentHandler = () => {
        setShowAddCommentModal(false);
    }

    return (
        <IonPage className="blog-detail">
            <Toolbar title={title} hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                {activeComponent}
            </IonContent>

            {addCommentButtonVisible ?
                <AddComment id={match.params.blog_id} type="blog" show={showAddCommentModal} clickShow={showCommentHandler} clickHide={hideCommentHandler} commentPostDone={hideCommentHandler} />
                : null}
        </IonPage>
    )
}

export default BlogDetailPage